// "Keep my workspace" from a clean-up warning email (spec §15.5): one click,
// no sign-in. The signed link can only mark that workspace as used.
import { post } from '../api.ts';
import { h } from '../util/dom.ts';
import { centered, mount, setTitle } from './page.ts';

export async function keepPage(token: string): Promise<void> {
  setTitle('Keep your workspace');
  try {
    const { workspace } = await post<{ workspace: string }>('/api/keep', { token }, { redirectOn401: false });
    mount(centered(
      h('h1', {}, ['Thanks, it’s kept']),
      h('p', {}, [h('strong', {}, [workspace]), ' won’t be deleted. Using it from time to time keeps it, too.']),
      h('a', { class: 'btn primary', href: '/' }, ['Open Atomic Lab']),
    ));
  } catch (err) {
    mount(centered(
      h('h1', {}, ['That link didn’t work']),
      h('p', { class: 'muted' }, [(err as Error).message, ' Signing in keeps your workspaces too.']),
      h('a', { class: 'btn primary', href: '/login' }, ['Sign in']),
    ));
  }
}
